module.exports = __webpack_public_path__ + "img/kiosk-h5-clean.3d03143f.png";